/** @jsxImportSource @emotion/react */
import React from 'react';
import InfoIcon from 'ud-ui/components/icon/info-icon';
import Text from 'ud-ui/components/text';
import UDTippy from 'ud-ui/components/tippy';
import type { DivProps } from '../../../../../../typings';
import * as S from './styles';
import { IconWrapper } from './styles';

interface IProps extends DivProps {
  tip?: string;
}

function Header(props: IProps) {
  const { tip, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <Text type="callout" color="inherit">
        {rest.children}
      </Text>
      <UDTippy content={tip}>
        <IconWrapper>
          <InfoIcon />
        </IconWrapper>
      </UDTippy>
    </S.MainBlock>
  );
}

export default Header;
